import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    assignJob,
    changeStatus,
    turnDownJob,
    createNewInspection,
    getInspectionsByDate,
    getInspectionsByAddress,
    updateInspectionWithAdditionalNotes,
    prepareDataForReport,
    setNewInspectionIdCreated,
    deleteInspectionAttachment,
    getInspectionDetailById,
    getInspectionsByFilter
} from '../actions/inspection_action';

export default function InspectionContainer(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component);
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeStatus,
        turnDownJob,
        assignJob,
        getInspectionsByDate,
        getInspectionsByAddress,
        createNewInspection,
        updateInspectionWithAdditionalNotes,
        prepareDataForReport,
        setNewInspectionIdCreated,
        deleteInspectionAttachment,
        getInspectionDetailById,
        getInspectionsByFilter
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        successStatus: state.inspection.successStatus,
        statusMessage: state.inspection.responseMessage,
        inspectionDataByDate: state.inspection.inspectionDataByDate,
        isListFetching: state.inspection.isFetching,
        inspectionDataForReport:state.inspection.reportData,
        newInspectionId:state.inspection.inspectionId,
        isDetailsFetching:state.inspection.isDetailsFetching,
        selectedInspection:state.inspection.selectedInspection
    };
}



// WEBPACK FOOTER //
// ./src/containers/inspection_container.js